// extracted by mini-css-extract-plugin
export default {"iconComponentContainer":"DisabledIcon_iconComponentContainer__MKRSa"};